import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface NotificationState {
    hasMessage: boolean;
    hasApplication: boolean;
    hasNotifications: boolean;
    count: number;
    read: string[];
}

const initialState: NotificationState = {
    hasMessage: false,
    hasApplication: false,
    hasNotifications: false,
    count: 0,
    read: []
}

export const notificationSlice = createSlice({
    name: 'Notification',
    initialState,
    reducers: {
        setHasNotifications(state, action: PayloadAction<NotificationState["hasNotifications"]>){
            state.hasNotifications = action.payload;
        },
        setHasMessage(state, action: PayloadAction<NotificationState["hasMessage"]>){
            state.hasMessage = action.payload;
        },
        setHasApplication(state, action: PayloadAction<NotificationState["hasApplication"]>){
            state.hasApplication = action.payload;
        },
        setRead(state, action: PayloadAction<NotificationState["read"]>){
            state.read = action.payload;
        },
        setNotficationCount(state, action: PayloadAction<NotificationState["count"]>){
            state.count = action.payload
        },
        addNotificationCount(state){
            state.count++;
        },
        subtractNotificationCount(state){
            state.count--;
        }
    }
})

export const {
    setHasNotifications,
    setHasMessage,
    setHasApplication,
    setRead,
    setNotficationCount,
    addNotificationCount,
    subtractNotificationCount
} = notificationSlice.actions

export default notificationSlice.reducer

